import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { IconDefinition } from '@fortawesome/free-solid-svg-icons'

@Component({
  selector: 'mu-button',
  templateUrl: './mu-button.component.html',
  styleUrls: ['./mu-button.component.scss'],
})
export class MuButtonComponent implements OnInit {
  @Input() class = ''
  @Input() disabled = false
  @Input() icon?: IconDefinition
  @Input() label: string
  @Input() animated = false
  @Input() variant: 'primary' | 'secondary' | 'noborder' = 'primary'
  // tslint:disable-next-line:no-output-on-prefix
  @Output() buttonClick = new EventEmitter()
  color: string

  ngOnInit() {
    this.class = `${this.class} ${this.variant}`
    this.color = this.variant
  }

  handleClick() {
    this.buttonClick.emit()
  }
}
